import React from 'react';
import { Hero } from '../components/sections/home/Hero';
import { PainPoints } from '../components/sections/home/PainPoints';
import { SolutionOverview } from '../components/sections/home/SolutionOverview';
import { HowItWorks } from '../components/sections/home/HowItWorks';
import { UseCases } from '../components/sections/home/UseCases';
import { SocialProof } from '../components/sections/home/SocialProof';
import { Security } from '../components/sections/home/Security';
import { PricingPreview } from '../components/sections/home/PricingPreview';
import { FinalCTA } from '../components/sections/home/FinalCTA';
export const Home = () => {
  return <>
      <Hero data-id="element-377" />
      <PainPoints data-id="element-378" />
      <PricingPreview data-id="element-379" />
      <SolutionOverview data-id="element-380" />
      <HowItWorks data-id="element-381" />
      <UseCases data-id="element-382" />
      <SocialProof data-id="element-383" />
      <Security data-id="element-384" />
      <FinalCTA data-id="element-385" />
    </>;
};